import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { PageTitle } from "../../common/PageTitle";
import { useDispatch } from "react-redux";
import { getAllUsers } from "../../../service";
import { Config } from "../../../utils/commonFuctions/Token";

import {
  setLoading,
  setPotSetting,
  setPotSettingList,
  setSelectedLeagues,
  setUsers,
  setWaitinglistpot,
} from "../../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { base_url } from "../../backendurl/url";
import { useState } from "react";
import UpdatePopup from "../../Leagues/UpdatePopup";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { Notification } from "../../common/Notification";
import { ConnectingAirportsOutlined } from "@mui/icons-material";

export default function WaitlistPots() {
  const navigate = useNavigate();
  const { PotSettingList } = useSelector((state) => state);
  const [notification, setnotification] = useState(false)
  const [loading,setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('')
  
  // Server-side pagination states
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState('');
  const [sortBy, setSortBy] = useState('');
  console.log(sortOrder,sortBy , "sortBy")
  
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");

  const PotListColumn = () => [
    {
      key: "id",
      label: "Round ID",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return (
          <Link
            component={Typography}
            style={{ color: "#3C50E0", textDecoration: "underline" }}
            to={`/rounds/view/${data.id}`}
            onClick={() => dispatch(setWaitinglistpot(data))}
          >
            {data["id"]}
          </Link>
        );
      },
    },
    { key: "category", label: "Round Category", align: "left", fontSize: "15px" },
    { key: "league", label: "League", align: "left", fontSize: "15px" },
    {
      key: "min_round_value_display",
      label: "Min Round Value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        // return `${data['pot_currency']}  ${data['min_pot_value']}`
        return `${data['min_round_value_display']}`
      }
    },
    {
      key: "max_round_value_display",
      label: "Max Round value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['max_round_value_display']}`
      }
    },
    {
      key: "round_value_display",
      label: "Round Value",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        // return `${data['pot_currency']}  ${data['current_pot_value']}`
        return `${data['round_value_display']}`
      }
    },
    { key: "admin_fee", label: "Admin Fee %", align: "left", fontSize: "15px" },
    {
      key: "joined_picks",
      label: "No. of Picks Joined",
      align: "center",
      fontSize: "14px",
      px: "10px",
    },
    {
      key: "current_match_week",
      label: "Current MW",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['current_match_week']}`
        // return `${data?.match_weeks?.current_match_week==null ? '-' :data?.match_weeks?.current_match_week  }`
      }
    },
     {
      key: "deadline_voting",
      label: "Deadline Voting Count",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['deadline_voting']}`
      }
    },
     {
      key: "tokens_per_pick",
      label: "Tokens Per Pick",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['tokens_per_pick']}`
      }
    },
    {
      key: "picks_per_player",
      label: "Picks Per Player",
      align: "left",
      fontSize: "15px",
      valueRenderer: (data) => {
        return `${data['picks_per_player']}`
      }
    },
  ];

  const getWaitlistPot = useCallback(async (page = 1, limit = 10, orderBy = '', order = '') => {
    //console.log(page, "page123")
    setLoading(true)
    dispatch(setPotSettingList([])); 
    try{
      // Build query parameters
      let queryParams = `page=${page}&limit=${limit}&status=Waitlist`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;

      }
      // console.log(`${base_url}/api/pot/rounds?${queryParams}`, "queryParams")
      const response = await Axios.get(`${base_url}/api/pot/rounds?${queryParams}`, Config);
      // console.log(response, "response111")
      
      if (response?.status == 200) {
        dispatch(setPotSettingList(response?.data?.results));
        setTotalCount(response?.data?.count); // Set total count from API response
        dispatch(setPotSetting({}));
        setLoading(false)
      }
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification)
      setLoading(false)
    }
  }, [dispatch]);

  // Handle pagination change from TransTable
  const handlePageChange = useCallback((page, rowsPerPage) => {
    setCurrentPage(page);
    setRowsPerPage(rowsPerPage);
    // API pages usually start from 1, but MUI pagination starts from 0
    getWaitlistPot(page + 1, rowsPerPage, sortBy, sortOrder);
  }, [sortBy, sortOrder, getWaitlistPot]);

  // Handle sorting change from TransTable
  const handleSortChange = useCallback((orderBy, order) => {
    setSortBy(orderBy);
    setSortOrder(order);
    // Reset to first page when sorting changes
    setCurrentPage(0);
    getWaitlistPot(1, rowsPerPage, orderBy, order);
  }, [rowsPerPage, getWaitlistPot]);

  const gotoAddUser = () => {
    navigate("add");
  };

  useEffect(() => {
    getWaitlistPot(1, 10); // Initial load
  }, [token]);

  return (
    <>
      <Box>
        <TransTable
          showSearch={false}
          checkbox={false}
          columns={PotListColumn()}
          rows={PotSettingList}
          addBtnAction={gotoAddUser}
          isLoading={loading}
          filter_keys={[
            "category",
            "league",
            "min_pot_value",
            "current_pot_value",
            "max_active_picks_voting"
          ]}
          // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
        />
        <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />
      </Box>
    </>
  );
}